import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("wisp_admin_token"));
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setChecking(false);
        setAuthed(false);
        return;
      }
      try {
        await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        setAuthed(true);
      } catch {
        localStorage.removeItem("wisp_admin_token");
        setToken(null);
        setAuthed(false);
      } finally {
        setChecking(false);
      }
    };
    verify();
  }, [token]);

  const login = useCallback(async (username, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { username, password });
    localStorage.setItem("wisp_admin_token", data.token);
    setToken(data.token);
    setAuthed(true);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("wisp_admin_token");
    setToken(null);
    setAuthed(false);
  }, []);

  return (
    <AuthContext.Provider value={{ token, authed, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
